<template lang="html">

  <section class="modulo-noticias row-center">

    <div class="container">

      <div class=" container-title animation">
        <h1 class="big-title animation" id="titulo-split" data-splitting="chars">{{$t('header.noticias')}}</h1>
      </div>

      <div class="contenedor-noticias row-between ais">

        <img src="/static/img/megafono.png" class="megafono" alt="megafono">

        <noticia v-for="(noticia, key) in noticias.slice(0,4)" :key="key" :data="noticia"></noticia>
      </div>

      <router-link class="btn -action" :to="$t('enlaces.noticias')">{{$t('vermas')}}</router-link>

    </div>

  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'
  import noticia from '@/components/parts/noticia-el'

  export default {
    name: 'modulo-noticias',
    methods: {
      ...mapActions(['requestNoticias'])
    },
    created() {
      this.requestNoticias();
    },
    computed: {
      ...mapGetters({
        noticias: 'getNoticias'
      }),
    },
    components: {
      'noticia': noticia
    }

  }
</script>

<style scoped lang="scss">
  .modulo-noticias {
    height: 100%;
    min-height: 900px;
    background: #e4e4e2;
    position: relative;

    .container-title {
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 0;
    }

    .contenedor-noticias {
      margin-top: 100px;
      position: relative;

      .noticia-el:nth-child(5) {
        display: none;
      }

      .megafono {
        position: absolute;
        left: 0;
        top: 0;
        max-width: 300px;
        transform: translate(-100px, -240px);
        z-index: 4;
      }
    }
  }

  .btn {
    margin-top: 30px;
  }

  @media screen and (max-width: 1650px) {
    .big-title {
      font-size: 170px;
    }
  }


  @media screen and (max-width: 1450px) {
    .big-title {
      font-size: 120px;
    }
  }

  @media screen and (max-width: 1023px) {
    .modulo-noticias {
      height: auto;
      padding: 100px 0;

      .container-title {
        position: relative;
        left: auto;
        top: auto;
        transform: translateX(0);
      }

      .contenedor-noticias {
        margin-top: 0;

        .noticia-el:nth-child(5) {
          display: inline-block;
        }
      }



    }

  }

  @media screen and (max-width: 850px) {
    .big-title {
      font-size: 100px;
      margin-bottom: 10px;
    }

    .megafono {
      display: none;
    }
  }

  @media screen and (max-width: 650px) {
    .modulo-noticias {
      padding: 50px 0;
    }
  }

  @media screen and (max-width: 470px) {
    .big-title {
      font-size: 64px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/home/modulo-noticias.vue